/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Cdi } from "./Cdi";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const CdisR = t.interface({
  cdis: t.readonlyArray(Cdi, "array of Cdi"),

  page_info: PageInfo
});

// optional attributes
const CdisO = t.partial({});

export const Cdis = t.intersection([CdisR, CdisO], "Cdis");

export type Cdis = t.TypeOf<typeof Cdis>;
